/*
These functions make sure WordPress
and Foundation play nice together.
*/

var $win = jQuery(window),
  $body = jQuery("body");
  $ = jQuery;

// jQuery(".nav-subscribe").on("click", function () {
//   jQuery("#ae-cform-modal-display-cta-2").trigger("click");
// });

// jQuery('#umg-live-gigs-table tr').each(function(event){
// 	// jQuery(this).children().slice(0, 3).wrapAll('<div class="umg-locations"/>')
// 	jQuery(this).children().slice(3).wrapAll('<div class="umg_tickets"/>')
// })	

// Remove empty P tags created by WP inside of Accordion and Orbit
jQuery(".accordion p:empty, .orbit p:empty").remove();

// Adds Flex Video to YouTube and Vimeo Embeds
jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(
  function () {
    if (jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5) {
      jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
    } else {
      jQuery(this).wrap("<div class='responsive-embed'/>");
    }
  }
);

$(window).on("scroll", function() {
  if($(window).scrollTop() > 50) {
      $(".top-bar").addClass("scrolled");
  } else {
      //remove the background property so it comes transparent again (defined in your css)
     $(".top-bar").removeClass("scrolled");
  }
});

if($body.hasClass('page-id-39')) {
  $('.faq').on('click', function(){
    $('.faq').removeClass('open');
    $(this).addClass('open');
  })
}



jQuery(window).on("load", function () {
  jQuery("#ae-cform-input-reg-email-1").attr("placeholder", "Email");

  jQuery(".top-bar .menu-bars").on("click", function () {
    jQuery(this).find(".fas").toggleClass("fa-times");
  });
  jQuery(".js-off-canvas-overlay").on("click", function () {
    jQuery(".top-bar .menu-bars .fas").removeClass("fa-times");
  });

  

  jQuery(".js-subscribe a").on("click", function (e) {
    e.preventDefault();

    var $target = jQuery(this).attr("href");

    jQuery("html, body").animate(
      {
        scrollTop: jQuery($target).offset().top,
      },
      800
    );

    if (jQuery(this).parents(".off-canvas")) {
      jQuery(".js-off-canvas-overlay").trigger("click");
    }
  });

  var $news = jQuery(".news-list")
setTimeout(function () {
  jQuery("#ae-cform-modal-display-cta-2").trigger("click");
}, 15000);

$news.slick({
  slidesToScroll: 3,
  slidesToShow: 1,
  speed: 500,
  cssEase: "ease-in-out",
  useTransform: true,
  dots: false,
  fade: true,
  responsive: [
    {
      breakpoint: 900,
      settings: {
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
})

  if($('.main-photos').length > 0) {
    $('.photos-container').masonry({
      itemSelector: '.photo',
      gutter: 20,
    });

    var $gallery = $(
      ".photos-container .photo a"
    ).simpleLightbox({
      animationSpeed: "200",
      className: "gallery-dark",
      scaleImageToRatio: true,
      widthRatio: 0.75,
      heightRatio: 0.75,
      showCounter: false,
    });  
  }

  if ($body.hasClass("home")) {
   
    function scrollDownNav(target) {
      event.preventDefault();
      $('.js-off-canvas-overlay').trigger('click')
      
      if(screen.width >= 1024) {
        $('html,body').animate({scrollTop: $(target).offset().top - 50},'slow');
      } else {
        $('html,body').animate({scrollTop: $(target).offset().top},'slow');
      }
    }

    $('.nav-music').on('click', function(event){
      scrollDownNav('#music')
    });
    $('.nav-videos').on('click', function(event){
      scrollDownNav('#videos')
    });
    $('.nav-film').on('click', function(event){
      scrollDownNav('#film')
    });
    $('.nav-tour').on('click', function(event){
      scrollDownNav('#tour')
    });
    $('.nav-about').on('click', function(event){
      scrollDownNav('#about')
    });
    $('.nav-store, .nav-merch').on('click', function(event){
      scrollDownNav('#merch')
    })

    if($('.umg-live-no-gigs').length > 0) {
      $('#tour .section-footer').hide();
    }


    jQuery(".article-video .play-button").on("click", function (e) {
      e.preventDefault();

      var youtubeID = jQuery(this).data("id"),
        embedCode =
          "<div class='media-youtube-video'><iframe src='https://www.youtube.com/embed/" +
          youtubeID +
          "?showinfo=0&autohide=1&rel=0&autoplay=1&wmode=transparent' frameborder='0' allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture' allowfullscreen></iframe></div>",
        $parent = jQuery(this).parents(".type-video");

      if (!document.querySelector(".media-youtube-video")) {
        $parent.addClass("playing");
        $parent.append(embedCode);
        jQuery(".js-video-list").addClass("has-embed");
      } else {
        $parent.removeClass("playing");
        jQuery(".media-youtube-video").remove();
        jQuery(".js-video-list").removeClass("has-embed");
      }
    });
    jQuery(".js-video-list > button").on("click", function () {
      if (jQuery(".article-video").hasClass("playing")) {
        jQuery(".media-youtube-video").remove();
        jQuery(".article-video").removeClass("playing");
        jQuery(".js-video-list").removeClass("has-embed");
      }
    });

    jQuery(".js-intro-arrow").on("click", function (e) {
      e.preventDefault();
  
      jQuery("html, body").animate(
        {
          scrollTop: jQuery(".section-music").offset().top - 64,
        },
        500
      );
    });

    jQuery('.anchor-down').on('click', function(e){
      e.preventDefault();
      var nextSection = jQuery(this).closest('.section').next();

      if(screen.width > 900) {
        var paddingTop = 150;
      } else {
        paddingTop = 0;
      }


      jQuery("html, body").animate(
        {
          scrollTop: jQuery(nextSection).offset().top - paddingTop,
        },
        500
      );

    })

    jQuery(".main-home .section").each(function () {
      var self = jQuery(this);

      jQuery(this).waypoint({
        handler: function (direction) {
          // if(direction == 'down') {
          // }

          // jQuery('.main-home .section').removeClass('show');
          self.addClass("show");
        },
        offset: "50%",
      });
    });

    if ($win.width() < 480) {
      var waypoints = jQuery(".section-about").waypoint({
        handler: function (direction) {
          if (direction == "up") {
            jQuery("#top-bar-menu .logo").removeClass("show");
          } else {
            jQuery("#top-bar-menu .logo").addClass("show");
          }
        },
        offset: "0",
      });
    }


  }
});
